import {
  nullableStreamId,
  RoomId,
  roomId,
  RoomStageLayout,
  roomStageLayout,
  StreamId,
  streamIds
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutStreamsSetEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutStreamsSetEventVO.validationSchema()
  );

  constructor(readonly value: RoomStageLayoutStreamsSetEvent) {
    JsonSchemaValidator.assert(
      RoomStageLayoutStreamsSetEventVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "layout", "videos", "audios"],
      properties: {
        roomId,
        layout: roomStageLayout,
        videos: streamIds,
        audios: streamIds,
        focus: nullableStreamId,
        main: nullableStreamId
      },
      additionalProperties: false
    };
  }
}

interface RoomStageLayoutStreamsSetEvent {
  roomId: RoomId;
  layout: RoomStageLayout;
  videos: StreamId[];
  audios: StreamId[];
  focus?: null | StreamId;
  main?: null | StreamId;
}
